export const GET_USER_COURSES_PAGE = 'GET_USER_COURSES_PAGE'
export const GET_USER_COURSES_PAGE_LOADING = 'GET_USER_COURSES_PAGE_LOADING'
export const GET_USER_COURSES_PAGE_SUCCESS = 'GET_USER_COURSES_PAGE_SUCCESS'
export const GET_USER_COURSES_PAGE_ERROR = 'GET_USER_COURSES_PAGE_ERROR'

export const GET_USER_COURSES = 'GET_USER_COURSES'
export const GET_USER_COURSES_LOADING = 'GET_USER_COURSES_LOADING'
export const GET_USER_COURSES_SUCCESS = 'GET_USER_COURSES_SUCCESS'
export const GET_USER_COURSES_ERROR = 'GET_USER_COURSES_ERROR'
